import { useEffect } from "react";
import AnalyticsService from "services/AnalyticsService";

/**
 * AnalyticsProvider is a React component that initializes the analytics service when it mounts and cleans up when it unmounts.
 */
function AnalyticsProvider() {
  useEffect(() => {
    AnalyticsService.init();

    return () => {
      AnalyticsService.clear();
    };
  }, []);

  return null;
}

export default AnalyticsProvider;
